import am from '@services/languages/am.json';
import en from '@services/languages/en.json';
import fr from '@services/languages/fr.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { appThemeConfiguration } from '@appConfig';
// the translations
const resources = {
  En: {
    translation: en,
  },
  Am: {
    translation: am,
  },
  Fr: {
    translation: fr,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: appThemeConfiguration.FALL_BACK_LANG ?? 'En',
    // if you're using a language detector, do not define the lng option
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
